module.exports = __webpack_public_path__ + "76f072945184de6cf103e08b9ab73a5c.svg";